import { BaseLocationFragment } from "../../../../../../generated/graphql.generated";
import { EventLocationTypes } from "../../../../../global.constants";

export interface EditableLocation {
  id: string;
  locationType?: EventLocationTypes;
  estimatedTimeAtLocation: number;
  totalTravelTimeToNextLocation: number;
  distanceToNextLocation: number;
  collapsed: boolean;
  order: number;
  location?: BaseLocationFragment;
}

export const eventItineraryInitialState = {
  eventItinerary: {
    includeDockTravel: false as boolean,
    locations: {} as { [ locationId: string ]: EditableLocation },
    saveEventCountdown: 0 as number,
    saveEventCountdownActive: false as boolean,
  }
} as const;

export type EventItineraryState = typeof eventItineraryInitialState;
